import { ServerEnv } from 'Configs/ServerEnv'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'

import { proxiedGet, proxiedPost, proxiedPut, buildQueryObject } from 'Services/apiClient'

const domain = `https://${ServerEnv.MemberCalls2()}.unicity.com`

const putHotFormatV2 = (data, countryCode3Alpha, isSkipValidate, queryStringOptions = null) => {
    const params = buildQueryObject(isSkipValidate ? { isSkipValidate: 1 } : null, queryStringOptions)
    const url = `${domain}/hot/formatV2/${countryCode3Alpha}/feelGreat/address`

    return proxiedPut(url, data, { params })
}

const createUuid = (data, countryCode3Alpha) => {
    const url = `${domain}/hot/formatV2/${countryCode3Alpha}/feelGreat/address`

    return proxiedPost(url, data)
}

const putAddress = (data, countryCode3Alpha) => {
    const url = `${domain}/hot/formatV2/${countryCode3Alpha}/feelGreat/address`
    console.log('putAddress')
    return proxiedPut(url, data)
}

const putAddressAddItemQty = (data, countryCode3Alpha) => {
    const url = `${domain}/hot/formatV2/${countryCode3Alpha}/feelGreat/address?isSkipValidate=1`

    return proxiedPut(url, data)
}

const getHotFormatV2 = (uuid, countryCode3Alpha, calc, isExpandGenBeta = true, useProductCredit = undefined) => {
    const IsGetOrderCalc = ['JP', 'TH', 'MY', 'TW', 'SA', 'AU'].includes(storeCountry.Country2()) ? true : calc

    const url = `${domain}/hot/format/${countryCode3Alpha}/feelGreat/detail-v2/${uuid}`
    const params = buildQueryObject(
        IsGetOrderCalc ? { ordercalC: 1 } : null,
        { expandGenBeta: isExpandGenBeta ? 1 : 0 },
        useProductCredit === undefined ? null : { useProductCredit: useProductCredit ? 'true' : 'false' }
    )

    return proxiedGet(url, { params })
}

const postHotFormatWithConfirmPassword = (data, countryCode3Alpha) => {
    const url = `${domain}/hot/formatV2/${countryCode3Alpha}/feelGreat/address`

    return proxiedPut(url, data, { params: { password2: 1 } })
}

const checkDuplicateOrder = ({ countryCode3Alpha, uuid }) => {
    const url = `${domain}/hot/payment_router/duplicateOrder/${countryCode3Alpha}/feelGreat/${uuid}`

    return proxiedGet(url)
}

const checkDuplicateAutoship = ({ countryCode3Alpha, uuid, token }) => {
    const url = `${domain}/proxy/${countryCode3Alpha}/feelGreat/duplicates/check`
    const params = ServerEnv.ENV === 'DEV' ? { isQa: 1 } : undefined

    return proxiedPost(url, { uuid }, {
        params,
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    })
}

const checkCartLimit = ({ data, token }) => {
    const url = `${domain}/cart-limit/public/check`
    return proxiedPost(url, data, { config: { headers: { 'Authorization-hydra': `Bearer ${token}` } } })
}

export const FormatAPIs = {
    putAddressAddItemQty,
    getHotFormatV2,
    putHotFormatV2,
    createUuid,
    putAddress,
    postHotFormatWithConfirmPassword,
    checkDuplicateOrder,
    checkDuplicateAutoship,
    checkCartLimit
}
